import { isTransitionalPeriodActive } from 'shared/ncts/common/constants'

const E1103Validator = {
  getIdentificationNumberMaxLength: () => (isTransitionalPeriodActive() ? 27 : 35),
} as const

export default E1103Validator
